import React from "react";
import { Box, Chip, Typography, Avatar } from "@mui/material";
import { CrewMember } from "./site-visit.types";

interface SelectedCrewChipsProps {
  selectedMembers: CrewMember[];
  onRemove: (member: CrewMember) => void;
}

const SelectedCrewChips: React.FC<SelectedCrewChipsProps> = ({
  selectedMembers,
  onRemove,
}) => {
  if (selectedMembers.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 1, display: "block" }}
      >
        Selected Crew Members ({selectedMembers.length})
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {selectedMembers.map((member) => (
          <Chip
            key={member.id}
            label={`${member.user.first_name} ${member.user.last_name}`}
            onDelete={() => onRemove(member)}
            avatar={
              <Avatar
                src={member.user.profile_picture || undefined}
                alt={`${member.user.first_name} ${member.user.last_name}`}
              >
                {member.user.first_name.charAt(0)}
              </Avatar>
            }
            size="small"
            color="primary"
            variant="outlined"
          />
        ))}
      </Box>
    </Box>
  );
};

export default SelectedCrewChips;
